import {useContext} from "react";
import {connect} from "react-redux";

const React = require("react");

export const AppConfig = React.createContext({});